<template>
  <v-card rounded="xl" color="error">
    <payment-user-info
      :item="item"
      :settings="settings"
      color="error"
      text-color="white--text"
    ></payment-user-info>
    <v-card-text>
      <v-row>
        <v-col cols="12" v-for="(transaction, i) in item.order.transaction" :key="i">
          <payment-order-meal-card
            v-if="item.order.transaction.length > 1"
            :transaction="transaction"
            :settings="settings"
          />
          <payment-order-big-meal-card
            v-else
            :transaction="transaction"
            :settings="settings"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="grey lighten-2" style="padding: 16px 0px">
      <v-row no-gutters justify="space-between">
        <v-col
          cols="12"
          class="poppins-bold pa-0 error--text"
          align="center"
          style="font-size: 32px"
        >
          {{ translate(item.user.message.lastStatusMessage) }}
        </v-col>
        <v-col
          cols="12"
          class="error--text poppins-medium pa-0"
          align="center"
          style="font-size: 20px"
        >
          {{ moment(item.order.updated_at).format("DD.MM.YYYY. HH:mm") }}
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import conf from "@/config";
import moment from "moment";
import PaymentUserInfo from "@/components/canteen/cards/components/PaymentUserInfo.vue";
import PaymentOrderMealCard from "@/components/canteen/cards/components/PaymentOrderMealCard.vue";
import PaymentOrderBigMealCard from "@/components/canteen/cards/components/PaymentOrderBigMealCard.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
    },
    last: {
      type: Boolean,
    },
  },
  components: {
    PaymentUserInfo,
    PaymentOrderMealCard,
    PaymentOrderBigMealCard,
  },
  data() {
    return {
      conf,
      moment,
    };
  },
  computed: {
    lighten() {
      return !this.item.user.message.success || this.last;
    },
    foodFontSize() {
      if (this.device?.isMobile) return (this.settings.font.size.food || 24) - 4 + "px";
      if (this.device?.isTablet) return (this.settings.font.size.food || 24) - 2 + "px";
      return (this.settings.font.size.food || 24) + "px";
    },
    foodImgSize() {
      if (this.device?.isMobile) return (this.settings.image.size || 100) - 30;
      if (this.device?.isTablet) return (this.settings.image.size || 100) - 10;
      return this.settings.image.size || 100;
    },
    cardBackground() {
      // Responsive background if needed, else fallback to original logic
      return !this.item.user.message.success
        ? "background: linear-gradient(0deg, rgba(213, 19, 21, 1) 0%, rgba(239, 7, 10, 1) 100%)"
        : this.last
        ? "background: linear-gradient(0deg, rgba(247, 150, 89, 1) 0%, rgba(253, 191, 127, 1) 100%)"
        : "background: linear-gradient(0deg, rgba(248, 249, 248, 1) 0%, rgba(234, 234, 234, 1) 100%)";
    },
  },
};
</script>

<style scoped>
.poppins-medium {
  font-family: Tahoma, sans-serif;
  font-weight: 500;
  font-style: normal;
}

.payment-order-card {
  background: #ffbd7e;
  background: linear-gradient(
    174deg,
    rgba(255, 189, 126, 1) 0%,
    rgba(243, 115, 56, 1) 100%
  );
}

.payment-taken-card {
  background-color: #b71528;
}
</style>
